import { Flame, TrendingUp, Clapperboard, Rocket, ShieldAlert } from "lucide-react";

function GoogleIcon() {
  return (
    <svg className="w-5 h-5" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.3 6.1 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/>
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.3 6.1 29.4 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
      <path fill="#4CAF50" d="M24 44c5.2 0 10-2 13.6-5.2l-6.3-5.3C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.2-7.9l-6.5 5C9.6 39.6 16.2 44 24 44z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.3 5.3C41.4 35.9 44 30.4 44 24c0-1.3-.1-2.3-.4-3.5z"/>
    </svg>
  );
}

const features = [
  { icon: TrendingUp, title: "Spot trends early", desc: "AI + real YouTube signal surfaces topics before they peak." },
  { icon: Clapperboard, title: "Auto-make videos", desc: "Scripts, voiceover, scenes & captions stitched into a ready MP4." },
  { icon: Rocket, title: "Autopilot publish", desc: "Produce daily and upload straight to your channel on schedule." },
];

export default function Landing() {
  const denied = new URLSearchParams(window.location.search).get("denied") === "1";

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] grain text-white flex flex-col" data-testid="landing-page">
      <header className="px-6 lg:px-10 py-6 flex items-center gap-2">
        <div className="w-9 h-9 rounded-md bg-brand flex items-center justify-center">
          <Flame className="w-5 h-5 text-white" strokeWidth={2} />
        </div>
        <div>
          <div className="font-heading text-lg font-semibold leading-none tracking-tight">TrendForge</div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-white/40 font-mono mt-1">Creator OS</div>
        </div>
      </header>

      <main className="flex-1 flex items-center px-6 lg:px-10">
        <div className="max-w-5xl mx-auto w-full grid lg:grid-cols-2 gap-14 items-center py-16">
          <div className="fade-up">
            <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-brand font-mono border border-brand/30 rounded-full px-3 py-1 mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-brand pulse-dot" /> Turn trends into revenue
            </div>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-5">
              Find what's about to blow up. <span className="text-brand">Ship the video.</span>
            </h1>
            <p className="text-white/50 text-base max-w-md mb-8 leading-relaxed">
              Your AI content engine for YouTube — discover trends, generate full video packages, and auto-publish on autopilot.
            </p>
            <button onClick={signIn} data-testid="google-signin-btn"
              className="inline-flex items-center gap-3 bg-white text-[#111] font-medium rounded-md px-6 py-3 text-sm hover:bg-white/90 transition-colors">
              <GoogleIcon /> Sign in with Google
            </button>
            {denied && (
              <div className="mt-4 flex items-start gap-2 text-sm text-brand bg-brand/10 border border-brand/30 rounded-md px-3 py-2 max-w-md" data-testid="access-denied">
                <ShieldAlert className="w-4 h-4 mt-0.5 shrink-0" />
                <span>That Google account isn't approved for this app. Sign in with an authorized account.</span>
              </div>
            )}
            <p className="text-[11px] text-white/30 mt-4 font-mono">Free to start · no card required to sign in.</p>
          </div>

          <div className="space-y-3 fade-up">
            {features.map((f) => (
              <div key={f.title} className="bg-surface border border-white/10 rounded-md p-5 flex items-start gap-4 hover:border-white/25 transition-colors">
                <div className="w-10 h-10 rounded-md bg-brand/15 border border-brand/30 flex items-center justify-center shrink-0">
                  <f.icon className="w-5 h-5 text-brand" strokeWidth={1.5} />
                </div>
                <div>
                  <div className="font-heading text-lg leading-tight">{f.title}</div>
                  <p className="text-sm text-white/50 mt-1 leading-relaxed">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <footer className="px-6 lg:px-10 py-6 text-[11px] text-white/25 font-mono border-t border-white/10">
        © {new Date().getFullYear()} TrendForge · Creator OS
      </footer>
    </div>
  );
}
